/**
 * Created by Ram on 11/04/2017.
 */

import React, { Component } from 'react';
import EditTestInstance from '../presentation/EditTestInstance';
import AddDevicesToTestWidget from './AddDevicesToTestWidget';
import dynamicSort from '../../logic/DynamicSort';
import * as validate from '../../util/validations';

class EditTestInstanceWidget extends Component {
    state = {
        devices: [],
        scenarios: [],
        scenario: '',
        scenarioId: '',
        testName: '',
        testMode: '',
        sdkVersion: '',
        sdkBuildNumber: '',
        appVersion: '',
        duration: '',
        comments: '',
        testInstanceId: this.props.pageParameters && this.props.pageParameters[0] ? this.props.pageParameters[0] : null,
        testInstance: '',
        editingDevices: false,
        isProduction: true,
        enableBackgroundLocationIndicator: false,
        enableBGMode: false,
        sortLocal: 'name',
        sortLocalAsc: true,
        showRemoteConfig: false,
        configurationParameters: {},
        isClone: this.props.pageParameters && this.props.pageParameters[1] ? this.props.pageParameters[1] === "clone" : false,
    };

    componentDidMount() {
        if (this.state.testInstanceId) {
            this.getSingleTestInstance(this.state.testInstanceId);
        }
        this.getScenarioList();
    }

    isAddNewMode = () => {
        let isAddNewMode = this.props.pageParameters == null || this.state.isClone;
        return isAddNewMode;
    };

    removeDevice = removeDevice => {
        let devices = this.state.devices;
        devices.splice(devices.indexOf(removeDevice), 1);
        this.setState({ devices });
    };

    removeAllSelectedDevices = () => {
        if (confirm('Are you sure you want to delete all selected devices?')) {
            let devices = this.state.devices;
            devices.splice(0, devices.length);
            this.setState({ devices });
        }
    };

    updateFormState = e => {
        let obj = {};
        if (e.target.name === 'isProduction') {
            obj[e.target.name] = !this.state.isProduction;
        } else if (e.target.name === 'enableBackgroundLocationIndicator') {
            obj[e.target.name] = !this.state.enableBackgroundLocationIndicator;
        } else  if (e.target.name === 'enableBGMode') {
            obj[e.target.name] = !this.state.enableBGMode;
        } else {
            obj[e.target.name] = e.target.value;
        }

        this.setState(obj);

        if (e.target.name === 'scenarioId') {
            this.getRemoteConfigDetails(e.target.value);
        }
    };

    sortLocalTable = sortByLocal => {
        const updateSortedList = () =>
            this.setState(prevState => ({
                devices: prevState.devices.sort(dynamicSort(this.state.sortLocal, this.state.sortLocalAsc ? 1 : -1)),
            }));

        if (sortByLocal === this.state.sortLocal) {
            this.setState(prevState => ({ sortLocalAsc: !prevState.sortLocalAsc }), updateSortedList);
        } else {
            this.setState({ sortLocal: sortByLocal }, updateSortedList);
        }
    };

    changeDateFormat = date => {
        let dateFormat = '';
        if (date) {
            dateFormat = date.substring(0, 19);
        }
        return dateFormat;
    };

    getSingleTestInstance = testInstanceId => {
        fetch('/service/getSingleTestInstanceDetails?testInstanceId=' + testInstanceId, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        }).then(response => {
            if (response.status !== 200) {
                this.setState({
                    error: 'An error has occurred fetching single test instance details',
                });
            } else {
                response.json().then(testInstance => {
                    let testInstanceIdSave = testInstanceId;
                    if (this.state.isClone) {    
                        testInstance.testInstanceId = null; // clear testInstanceId as we are creating a clone
                        testInstance.name = "Clone of " + testInstance.name;
                        testInstance.duration = ''; // duration in most cases is calculated by endTime - startTime, we don't want to copy that
                        testInstanceIdSave = null;
                    }

                    this.setState({
                        testInstance: testInstance,
                        testInstanceId: testInstanceIdSave,
                        scenarioId: testInstance.scenarioId || '',
                        testName: testInstance.name,
                        testMode: testInstance.mode,
                        sdkVersion: testInstance.sdkVersion,
                        sdkBuildNumber: testInstance.sdkBuildNumber || '',
                        appVersion: testInstance.appVersion || '',
                        duration: testInstance.duration || '',
                        comments: testInstance.comments,
                        isProduction: testInstance.isProduction,
                        enableBackgroundLocationIndicator: testInstance.enableBackgroundLocationIndicator,
                        enableBGMode: testInstance.enableBGMode,
                        configurationParameters: testInstance.configurationParameters,
                    });
                    this.getTestInstanceDevices(testInstance);
                });
            }
        });
    };

    getTestInstanceDevices = testInstance => {
        let devices = [];
        testInstance.devices.map(testDevice => {
            devices.push(testDevice.deviceId);
        });

        fetch('/service/getClusterDevices?devices=' + devices, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        }).then(response => {
            if (response.status === 200) {
                response.json().then(devices => {
                    this.setState({ devices });
                });
            }
        });
    };

    getScenarioList = () => {
        fetch('/service/scenarios', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        }).then(response => {
            if (response.status === 200) {
                response.json().then(scenarios => {
                    this.setState({ scenarios });
                });
            }
        });
    };

    displayRemoteConfigDetails = () => {
        const { scenarioId } = this.state;

        if (scenarioId) {
            this.setState({
                error: null,
                errorField: null,
                showRemoteConfig: true,
            });
        } else {
            this.setState({
                error: 'Please select a Scenario',
                errorField: 'remoteConfig',
            });
        }
    };

    getRemoteConfigDetails = scenarioId => {
        fetch(`/service/getRemoteConfigDetails?scenarioId=${scenarioId}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        }).then(response => {
            if (response.status === 200) {
                response.json().then(configurationParameters => {
                    this.setState({ configurationParameters });
                });
            } else if (response.status === 204) {
                this.setState({ configurationParameters: {} });
            }
        });
    };

    validateInput = () => {
        const { testName, testMode, devices, sdkVersion } = this.state;

        if (validate.required(testName)) {
            this.setState({
                error: 'Please enter a test name',
                errorField: 'testName',
            });
        } else if (validate.required(testMode)) {
            this.setState({
                error: 'Please select a test mode',
                errorField: 'testMode',
            });
        } else if (validate.required(sdkVersion)) {
            this.setState({
                error: 'Please enter a SDK Version',
                errorField: 'sdkVersion',
            });
        } else if (!devices.length) {
            this.setState({
                error: 'Please select at least one device',
                errorField: 'selectedDevices',
            });
        } else {
            this.setState({ error: false });
            return true;
        }
    };

    handleHideModal = () => {
        this.setState({ showRemoteConfig: false });
    };

    handleSave = () => {
        let trackingDevice = { hostReady: false };

        const {
            devices,
            scenarioId,
            testName,
            testMode,
            duration,
            sdkVersion,
            sdkBuildNumber,
            appVersion,
            comments,
            testInstanceId,
            isProduction,
            enableBackgroundLocationIndicator,
            enableBGMode,
            configurationParameters,
            scenarios
        } = this.state;

        const scenarioToBeSaved = scenarios.find(scenario => scenario._id === scenarioId);

        const devicesOnInstance = devices.map(device => {
            let deviceSelected = {};

            if (device.trackingDevice) {
                deviceSelected = trackingDevice;
            } else if (this.state.testMode === 'Host-only') {
                deviceSelected['hostReady'] = false;
            } else if (this.state.testMode === 'Both') {
                deviceSelected['batteryReady'] = false;
                deviceSelected['hostReady'] = false;
            } else if (this.state.testMode === 'Battery-only') {
                deviceSelected['batteryReady'] = false;
            }

            // HERE

            deviceSelected['deviceId'] = device._id;
            deviceSelected['identifier'] = device.identifier;
            deviceSelected['name'] = device.name;
            deviceSelected['os'] = device.os;
            deviceSelected['osVersion'] = device.osVersion;
            deviceSelected['model'] = device.model;
            

            return deviceSelected;
        });

        if (scenarioId === 'Select scenario') {
            this.setState({ scenarioId: '' });
        }

        let body = {
            name: testName,
            scenarioId: scenarioId && scenarioId.trim() !== 'Select scenario' ? scenarioId : '',
            devices: devicesOnInstance,
            mode: testMode,
            duration,
            sdkVersion,
            sdkBuildNumber,
            appVersion,
            comments,
            testInstanceId,
            isProduction,
            enableBackgroundLocationIndicator,
            enableBGMode,
            configurationParameters: configurationParameters ? configurationParameters : null,
            scenario: scenarioToBeSaved
        };

        this.setState({ serverError: '', success: '' });

        if (this.validateInput()) {
            fetch('/service/editTestInstance', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify(body),
            }).then(response => {
                if (response.status !== 200) {
                    response.json().then(json => {
                        this.setState({ serverError: json });
                    });
                } else {
                    this.setState({ success: 'Changes saved successfully' });
                    if (this.isAddNewMode()) {
                        this.props.navigator.requestTestInstanceManagement();
                    }
                }
            }).catch(console.error);
        }
    };

    deleteTestInstance = () => {
        if (confirm('Are you sure you want to delete the test instance?')) {
            fetch('/service/deleteTestInstance', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ testInstanceId: this.state.testInstanceId }),
            }).then(response => {
                if (response.status !== 200) {
                    this.setState({
                        serverError: 'Error! Test Instance could not be deleted',
                    });
                } else {
                    response.json().then(json => {
                        alert('Test Instance  ' + json.testInstance.name + ' has been deleted successfully');
                        this.props.navigator.requestTestInstanceManagement();
                    });
                }
            });
        }
    };

    toggleAddDevices = () => {
        this.setState(prevState => ({ editingDevices: !prevState.editingDevices }));
    };

    setDevices = devices => {
        this.setState({ devices }, () => { this.toggleAddDevices() });
    };

    render() {
        const { editingDevices, devices, testInstanceId } = this.state;
        const { navigator } = this.props;

        if (editingDevices) { 
            return (
                <AddDevicesToTestWidget
                    toggleAddDevices={this.toggleAddDevices}
                    updateTestDevices={this.setDevices}
                    currentDevices={devices}
                    navigator={navigator}
                    testInstanceId={testInstanceId}
                    displayRemoteConfigDetails={this.displayRemoteConfigDetails}
                    handleHideModal={this.handleHideModal}
                />
            );
        } else {
            return (
                <EditTestInstance
                    navigator={navigator}
                    loadData={this.state}
                    removeDevice={this.removeDevice}
                    removeAllSelectedDevices={this.removeAllSelectedDevices}
                    updateFormState={this.updateFormState}
                    handleSave={this.handleSave}
                    handleAddDevices={this.toggleAddDevices}
                    changeDateFormat={this.changeDateFormat}
                    deleteTestInstance={this.deleteTestInstance}
                    sortLocalTable={this.sortLocalTable}
                    displayRemoteConfigDetails={this.displayRemoteConfigDetails}
                    handleHideModal={this.handleHideModal}
                />
            ); //return
        }
    } //render
} //EditTestInstanceWidget

export default EditTestInstanceWidget;
